import React, { useContext, useState, useCallback } from 'react'
import { Link, useParams, useLocation } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Carrossel from './../../Carrossel/Carrossel';
import Rodape from '../../Rodape/Rodape';
import Produtos_Cards from '../../Produtos_Cards/Produtos_Cards';
import Paginacoes from '../../Paginacao/Paginacao';
import Ordenacao from '../../Ordenacao/Ordenacao';
import { MyContext } from '../../../context/MyContext';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { identificacaoUsuarioLogado, setCookie, getCookie } from '../../../utils';
import { Typography } from '@mui/material';
import { ProgressBar } from 'react-bootstrap';
import { BrowserView, MobileView } from 'react-device-detect';
import { styled } from '@mui/material/styles';

function Produtos() {
  let history = useHistory();
  const { paginaAtual, setPaginaAtual, paginaTotal, setPaginaTotal } = useContext(MyContext);
  const { produtos, setProdutos } = useContext(MyContext);
  const { ultimaPesquisaProdutos, setUltimaPesquisaProdutos } = useContext(MyContext);
  const [jaPesquisei, setJaPesquisei] = useState("");
  const { produtosOrdem } = useContext(MyContext);
  const { posicaoOrdem, setPosicaoOrdem } = useContext(MyContext);
  const [showLoading, setShowLoading] = useState(false);
  const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
  const [linkProduto, setLinkProduto] = useState(0); // Usado Para Compartilhar Link de Produtos
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let _efetuandoAPI = false;

  useEffect(() => {
    if (!ultimaPesquisaProdutos) {
     // history.push("/");
    }
    rePesquisar();
  }, [ultimaPesquisaProdutos, paginaAtual, produtosOrdem, posicaoOrdem]);

  const rePesquisar = useCallback(() => {
    const _linkProduto = queryParams.get('codigo');
    if (_linkProduto == null && ultimaPesquisaProdutos != null && ultimaPesquisaProdutos != ""){ // && jaPesquisei != ultimaPesquisaProdutos) {
      Pesquisar_Produtos(ultimaPesquisaProdutos, paginaAtual, 15, produtosOrdem, posicaoOrdem);
    }else if (_linkProduto != null && _linkProduto > 0 && _linkProduto != ultimaPesquisaProdutos){
      Pesquisar_Unico_Produto(_linkProduto, 1, 1, produtosOrdem, posicaoOrdem);
    }
  }, [ultimaPesquisaProdutos, paginaAtual, produtosOrdem, posicaoOrdem]);


  async function Pesquisar_Produtos(prod, paginaAtual, take = 15, produtosOrdem, posicaoOrdem) {
    setShowLoading(true);
    let _ul = identificacaoUsuarioLogado();
    let __clienteID = _ul.split('_')[0];
    let __clienteIDLoja = _ul.split('_')[1];

    if (__clienteID == undefined || __clienteID == "") {
      __clienteID = 0;
      __clienteIDLoja = 0;
    }

    // prod.replace("/","¨") Utilizado Para Evitar Que a API Interprete as Barras / na Descrição com Outros Parâmetros      
    const data = await api.get(`Produtos/${prod.replaceAll("/", "¨")}/page/${paginaAtual}/setAmount/${take}/${produtosOrdem}/${posicaoOrdem}/${__clienteID}/${__clienteIDLoja}`)
      .then((res) => {        
        setPaginaTotal(Math.ceil(res.data?.amount / take));
        setUltimaPesquisaProdutos(prod);
        setJaPesquisei(prod);
        setProdutos(res.data);
      }).catch(err => {
        console.log(this.state.error);
      });
      setShowLoading(false);    
      // history.push("/produtos");
  }

  async function Pesquisar_Unico_Produto(prodCodigo, paginaAtual, take = 15, produtosOrdem, posicaoOrdem) {
    setShowLoading(true);
    let _ul = identificacaoUsuarioLogado();
    let __clienteID = _ul.split('_')[0];
    let __clienteIDLoja = _ul.split('_')[1];

    if (__clienteID == undefined || __clienteID == "") {
      __clienteID = 0;
      __clienteIDLoja = 0;
    }
    // prod.replace("/","¨") Utilizado Para Evitar Que a API Interprete as Barras / na Descrição com Outros Parâmetros      

    const data = await api.get(`Produtos/ProdutoDireto/${prodCodigo.replace(/\D/g, "")}/${__clienteID}/${__clienteIDLoja}`)
      .then((res) => {
        setProdutos(res.data);
        setPaginaTotal(1);        
        setUltimaPesquisaProdutos(prodCodigo);

        console.log("XXXXC ", res.data);

      }).catch(err => {
        console.log("Error: ", err);
        // console.log(this.state.error);

        console.log("XXXXD ", err);

      });
    setShowLoading(false);
    history.push("/produtos?codigo=" + prodCodigo);
  }

  console.log("XXXXF ", produtos, paginaAtual );

  return (
    <>
      <BrowserView>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          display="flex"
          columns={12}
        >
          <Grid item xs={12}>
            <NavBarTop />
          </Grid>

          <Grid
            container
            spacing={0}
            direction="row"
            marginTop={1}
            marginRight={'10px'}
            alignItems="center"
            columns={12}
            justifyContent="space-between"
          >
            <Grid item xs={4}>
              <Typography sx={{ marginTop: "10px", marginLeft: "10px", textAlign: "left" }}>{(produtos?.amount > 0 ? "Localizamos " + produtos?.amount + (produtos?.amount > 1 ? " Produtos" : " Produto") : <div></div>)}</Typography>
            </Grid>

            <Grid item xs={4} marginTop={'7px'}>
              <Typography component={Link} to={'/como_pesquisar_produtos'} sx={{ textAlign: "center", color: "#93C572" }}>{(produtos?.amount > 0 ? "Saiba Como Localizar os Produtos Desejados..." : <div></div>)}</Typography>
            </Grid>

            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', height: '100%', marginTop: "4px" }}>{(produtos?.amount > 0 ? <Ordenacao /> : <div></div>)}</Box>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            {(showLoading ? <ProgressBar /> : <Produtos_Cards produtos={produtos} />)}
          </Grid>
          <Grid item xs={12}>
            <Paginacoes paginaAtual={paginaAtual} paginaTotal={paginaTotal} />
          </Grid>
          <Grid item xs={12}>
            <Rodape />
          </Grid>
        </Grid >
      </BrowserView>

      <MobileView>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          display="flex"
          columns={12}
        >
          <Grid item xs={12}>
            <NavBarTop />
          </Grid>

          <Grid
            container
            spacing={0}
            direction="row"
            marginTop={1}
            marginRight={'10px'}
          >
            <Grid item xs={6}>
              <div><Typography fontSize={'14px'} sx={{ marginTop: "10px", marginLeft: "10px", textAlign: "left" }}>{(produtos?.amount > 0 ? "Localizamos " + produtos?.amount + (produtos?.amount > 1 ? " Produtos" : " Produto") : <div></div>)}</Typography></div>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ width: "200px", marginTop: "4px", alignItems: "right", alignContent: "right" }} marginRight={'90px'}>{(produtos?.amount > 0 ? <Ordenacao /> : <div></div>)}</Box>
            </Grid>
            <Grid item xs={12} marginTop={'7px'}>
              <Typography component={Link} to={'/como_pesquisar_produtos'} sx={{ textAlign: "center", color: "#93C572" }}>{(produtos?.amount > 0 ? "Saiba Como Localizar os Produtos Desejados..." : <div></div>)}</Typography>
            </Grid>
          </Grid>

          <Grid item>
            {(showLoading ? <ProgressBar /> : <Produtos_Cards produtos={produtos} />)}
          </Grid>
          <Grid item xs={12}>
            <Paginacoes paginaAtual={paginaAtual} paginaTotal={paginaTotal} />
          </Grid>
          <Grid item xs={12}>
            <Rodape />
          </Grid>
        </Grid >
      </MobileView>
    </>
  )
}
export default Produtos